import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const Agitate = () => {
  const cards = [
    {
      icon: FiIcons.FiFileText,
      title: "FORMS GET IGNORED.",
      desc: "Nobody wants to fill out a box and wait for a callback. They close the tab — and that appointment never makes it to your calendar."
    },
    {
      icon: FiIcons.FiMessageSquare,
      title: "CHATBOTS GET IGNORED TOO.",
      desc: "The second visitors realize they're talking to a script, they stop trusting the answers. No trust, no appointment, no lead."
    },
    {
      icon: FiIcons.FiPhoneOff,
      title: "PHONE CALLS GET SKIPPED.",
      desc: "Picking up the phone feels like a commitment most visitors aren't ready to make. So they leave instead of calling — and you never even know they were there."
    }
  ];

  return (
    <section className="py-24 bg-navy-light relative border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-4xl mx-auto mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-anton uppercase tracking-wide text-white mb-6">
            EVERY VISITOR WHO LEAVES WITHOUT BOOKING IS <span className="text-gold">A LEAD YOU PAID FOR AND LOST.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {cards.map((card, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-navy p-8 rounded-2xl border border-white/5 hover:border-white/10 transition-colors"
            >
              <div className="w-14 h-14 bg-white/5 rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={card.icon} className="text-2xl text-gold" />
              </div>
              <h3 className="text-2xl font-anton uppercase tracking-wide text-white mb-4">
                {card.title}
              </h3>
              <p className="text-gray-400 font-medium leading-relaxed">
                {card.desc}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <p className="text-xl md:text-2xl font-medium text-gray-300">
            The real cost isn't a bad website experience. <br/>
            <span className="text-white font-bold border-b-2 border-red-500">It's the appointments and leads that never reach your team.</span>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Agitate;